<div class="container-md pb-4 p-md-0">
  <div class="card shadow-sm">
    <div class="card-body">
      <div class="row">
        <div class="col">
          <h4 class="mb-3">
            {{ 'travel_details' | translate }}
          </h4>
        </div>
      </div>

      <form
        *ngIf="form_array"
        [formGroup]="form"
        [tds-data-loader]="{ key: 'travel-details', as_overlay: true }"
      >
        <div
          *ngFor="let group of form_array.controls; index as i"
          class="row g-3 mb-3 travel-details flex-lg-nowrap"
          [formArrayName]="'travel_details'"
        >
          <div class="col-12 col-lg-4 col-md-6">
            <label for="country-{{ i }}" class="form-label required"> {{ countryLabel }} </label>
            <select
              id="country-{{ i }}"
              class="form-select"
              [class.is-invalid]="
                $any(group).get('country').errors && $any(group).get('country').dirty
              "
              [compareWith]="compareCountry"
              [formControl]="$any(group).get('country')"
            >
              <option value="">{{ 'select_one' | translate }}</option>
              <option *ngFor="let option of countryList" [ngValue]="option">
                {{ option.name }}
              </option>
            </select>

            <div
              *ngIf="
                $any(group).get('country').errors &&
                $any(group).get('country').dirty &&
                $any(group).get('country').errors['required']
              "
              id="country-{{ i }}-error"
              class="text-danger mt-2"
            >
              <span>
                {{ 'input_is_required' | translate : countryLabel }}
              </span>
            </div>
          </div>

          <div class="col-12 col-lg-4 col-md-6">
            <ts-date-picker
              id="arrival_date-{{ i }}"
              [label]="'travel_start_date' | translate"
              [name]="'arrival_date'"
              [required]="true"
              [control]="$any(group).get('arrival_date')"
              [validate_pattern]="true"
              [errors]="{
                min_date: ('travel_start_before_previous_end_error' | translate)
              }"
              [min_date]="
                i !== 0 &&
                form_array.controls.at(i - 1)?.get('departure_date')?.value &&
                formatDate(form_array.controls.at(i - 1)?.get('departure_date')?.value)
              "
            />
          </div>

          <div class="col-12 col-lg-4 col-md-6">
            <ts-date-picker
              id="departure_date-{{ i }}"
              [label]="'travel_end_date' | translate"
              [name]="'departure_date'"
              [required]="true"
              [control]="$any(group).get('departure_date')"
              [validate_pattern]="true"
              [errors]="{
                min_date: ('travel_end_before_start_error' | translate)
              }"
              [min_date]="
                $any(group).get('arrival_date').value &&
                formatDate($any(group).get('arrival_date').value)
              "
            />
          </div>

          <div class="w-auto delete-icon">
            <button
              class="btn btn-outline-secondary d-flex px-2"
              [disabled]="!(form_array && form_array.controls.length > 1)"
              (click)="removeDetails(i)"
            >
              <span class="material-icons fs-4">delete</span>
            </button>
          </div>
        </div>
      </form>

      <div class="row">
        <div class="col">
          <button
            class="btn btn-outline-secondary add-new"
            [disabled]="!limitTravelDetails"
            (click)="addNewDetails()"
          >
            {{ 'add_new' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ts-price-summary
  [hide_price_content]="false"
  [button_status]="!(form_array && form_array.controls.length) || (form && form.invalid)"
  [shopping_cart]="shopping_cart"
  [refresh_summary]="refresh_summary.asObservable()"
  (updateCostSummary)="getShoppingCartData($event)"
  (onContinueSuccess)="onContinueSuccess($event)"
/>
